enum HttpCodes {
  ok = 200,
  badRequest = 400,
  notFound = 404,
  internalServerError = 500,
}

enum ApiErrorRules {
  energyOnly = 'TENANTS_NOT_ALLOWED_ENERGY_ONLY',
  prepaymentMeter = 'PREPAYMENT_METERS_NOT_ALLOWED',
}

enum ApiErrorCodes {
  failedRule = 'FAILED_RULE',
  emailAlreadyRegistered = 'EMAIL_ALREADY_REGISTERED',
}

enum BasketQueryErrorMessages {
  accountIDNotSupported = 'CUSTOMER_ACCOUNT_ID_NOT_SUPPORTED',
  marshal = 'MARSHAL_ERROR',
  dbFailure = 'DATABASE_FAILURE',
  quoteRetrieval = 'UNABLE_TO_RETRIEVE_QUOTES',
  deriveMeterRequirements = 'UNABLE_TO_DERIVE_METER_REQUIREMENTS',
  requoteBasket = 'UNABLE_TO_REQUOTE_BASKET',
  populateQuoteRequirements = 'UNABLE_TO_POPULATE_QUOTE_REQUIREMENTS',
  domainLookup = 'DOMAIN_LOOKUP_ERROR',
}

enum TokenisationApiErrorMessages {
  invalidBody = 'invalid body',
  invalidValues = 'invalid account number or sortcode',
}

enum AddPaymentMethodErrorReasons {
  invalidUnspecified = 'INVALID_REASON_UNSPECIFIED',
  missingSortCode = 'INVALID_REASON_SORT_CODE_NOT_FOUND',
  invalidSortCode = 'INVALID_REASON_INVALID_SORT_CODE',
  invalidAccountNumber = 'INVALID_REASON_INVALID_ACCOUNT_NUMBER',
  invalidModulusCheck = 'INVALID_REASON_MODULUS_CHECK_FAILED',
  invalidRollNumber = 'INVALID_REASON_BUILDING_SOCIETY_ROLL_NUMBER_REQUIRED',
}

enum RetrieveSavedBasketErrorCodes {
  invalidToken = 'INVALID_RETRIEVAL_TOKEN',
  invalidPostcode = 'POSTCODE_VALIDATION_FAILURE',
}

enum AppointmentErrorCodes {
  appointmentNotFound = 'NOT_FOUND',
  appointmentAlreadyEnded = 'APPOINTMENT_ALREADY_ENDED',
  appointmentNotMember = 'NOT_MEMBER',
}
const DEFAULT_ERROR_MESSAGE = 'Oops! There was a problem, please try again.';

const apiDefaultErrors = [
  BasketQueryErrorMessages.accountIDNotSupported,
  BasketQueryErrorMessages.marshal,
  BasketQueryErrorMessages.dbFailure,
  BasketQueryErrorMessages.quoteRetrieval,
  BasketQueryErrorMessages.deriveMeterRequirements,
  BasketQueryErrorMessages.requoteBasket,
  BasketQueryErrorMessages.populateQuoteRequirements,
  BasketQueryErrorMessages.domainLookup,
  // any unhandled errors
  'rpc error',
  'unreturned error type',
];

enum QuoteIneligibleErrorMessages {
  oneCoreProductRequired = 'Requires 1 other Core Product',
  moreThanOneMoreProductRequired = 'Requires more than 1 other Core Product',
  atLeastOneRequirementProvided = 'at least one quote requirement needs to be provided before ordering',
  atLeastOneAccountHolderRequired = 'at least one account holder must be supplied',
  cashbackCardMustBeBundledWithAnotherService = 'Cashback card must be bundled with another service. Please add another service to continue.',
  insuranceMustBeBundledWithAnotherService = 'Insurance must be bundled with another service. Please add another service to continue.',
  simOnly = 'To continue with Mobile only, you can only have one SIM in your order.',
}

export {
  DEFAULT_ERROR_MESSAGE,
  apiDefaultErrors,
  HttpCodes,
  BasketQueryErrorMessages,
  TokenisationApiErrorMessages,
  AddPaymentMethodErrorReasons,
  ApiErrorRules,
  ApiErrorCodes,
  QuoteIneligibleErrorMessages,
  RetrieveSavedBasketErrorCodes,
  AppointmentErrorCodes,
};
